var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"role":"dialog"}},[_c('div',{class:['ya-modal', 'filter-modal', { 'remove-modal': _vm.type === 'remove' }]},[(_vm.type !== 'remove')?_c('div',{staticClass:"ya-modal__close",on:{"click":_vm.closePopup}},[_c('img',{attrs:{"src":"/images/close-icon.svg","alt":"close"}})]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }